import React from 'react';
import src from "./bug_net.png";

export default function BugNet(props) {
  const { visible } = props;

  let opacity = 0;
  let dy = 200;

  if (visible) {
    opacity = 1;
    dy = 0;
  }

  const style = { opacity, transform: `translateY(${dy}px)` };
  return <img src={src} className="letterfly-net" style={style} alt="letter fly net"/>;
}
